// extracted by mini-css-extract-plugin
export default {"deviceButton":"ToggleScreenShareButton_deviceButton__Mfrw6","icon":"ToggleScreenShareButton_icon__1AhUK"};